import { useState, useEffect } from "react";
import { useApp, api } from "../context";
import { AuthShell, FormInput, Btn } from "../components";

export const LoginPage = ({ loginForm, setLoginForm, doLogin, loading, formError, setFormError }) => {
  const { c, dark, setDark, go } = useApp();
  const hasToken = !!localStorage.getItem("gc_token");
  const savedName = localStorage.getItem("gc_saved_name") || null;
  const [showFull, setShowFull] = useState(false);

  if (hasToken && !showFull) {
    return (
      <AuthShell>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <div style={{ width: 64, height: 64, borderRadius: 20, background: "linear-gradient(135deg,#6c5ce7,#e91e8c)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 32, margin: "0 auto 14px" }}>👤</div>
          <h1 style={{ fontSize: 22, fontWeight: 800, margin: "0 0 6px", color: c.text }}>Welcome Back{savedName ? `, ${savedName.split(" ")[0]}` : ""}!</h1>
          <p style={{ fontSize: 13, color: c.sub, margin: 0 }}>Continue to Geilstore Community</p>
        </div>
        {formError && <div style={{ background: c.redBg, color: c.redTxt, padding: "9px 13px", borderRadius: 10, fontSize: 13, marginBottom: 14, textAlign: "left", border: `1px solid ${c.red}18` }}>{formError}</div>}
        <Btn primary full onClick={doLogin} disabled={loading} style={{ marginBottom: 12 }}>
          {loading ? "Loading..." : "Continue →"}
        </Btn>
        <button onClick={() => setShowFull(true)} style={{ width: "100%", padding: "11px", borderRadius: 11, border: `1px solid ${c.border}`, background: "transparent", color: c.sub, fontSize: 13, fontWeight: 600, cursor: "pointer", marginBottom: 14 }}>
          🔄 Switch Account
        </button>
        <div style={{ textAlign: "center", marginTop: 4 }}>
          <button onClick={() => setDark(!dark)} style={{ padding: "7px 14px", borderRadius: 8, border: `1px solid ${c.border}`, background: c.card, color: c.sub, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>{dark ? "☀️ Light" : "🌙 Dark"}</button>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell>
      <h1 style={{ fontSize: 22, fontWeight: 800, margin: 0, color: c.text }}>Welcome Back</h1>
      <p style={{ fontSize: 13, color: c.sub, margin: "6px 0 24px" }}>Sign in to Geilstore Community</p>
      {formError && <div style={{ background: c.redBg, color: c.redTxt, padding: "9px 13px", borderRadius: 10, fontSize: 13, marginBottom: 14, textAlign: "left", border: `1px solid ${c.red}18` }}>{formError}</div>}
      <FormInput label="EMAIL" type="email" placeholder="you@example.com" value={loginForm.email} onChange={e => setLoginForm({ ...loginForm, email: e.target.value })} autoComplete="username" />
      <FormInput label="PASSWORD" type="password" placeholder="••••••••" value={loginForm.password} onChange={e => setLoginForm({ ...loginForm, password: e.target.value })} onKeyDown={e => e.key === "Enter" && doLogin()} autoComplete="current-password" />
      <div style={{ textAlign: "right", marginBottom: 16 }}><button onClick={() => { go("forgot"); setFormError(""); }} style={{ background: "none", border: "none", color: c.pri, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>Forgot password?</button></div>
      <Btn primary full onClick={doLogin} disabled={loading}>{loading ? "Signing in..." : "Sign In"}</Btn>
      <p style={{ textAlign: "center", marginTop: 18, fontSize: 13, color: c.sub }}>Don't have an account? <button onClick={() => { go("register"); setFormError(""); }} style={{ color: c.pri, fontWeight: 700, cursor: "pointer", border: "none", background: "none", fontSize: 13 }}>Create Account</button></p>
      <div style={{ textAlign: "center", marginTop: 14 }}><button onClick={() => setDark(!dark)} style={{ padding: "7px 14px", borderRadius: 8, border: `1px solid ${c.border}`, background: c.card, color: c.sub, fontSize: 12, fontWeight: 600, cursor: "pointer" }}>{dark ? "☀️ Light" : "🌙 Dark"}</button></div>
    </AuthShell>
  );
};

export const RegisterPage = ({ regForm, setRegForm, doRegister, loading, formError, setFormError }) => {
  const { c, go } = useApp();
  const [showReferral, setShowReferral] = useState(false);

  // Auto-detect referral code from URL ?ref=CODE
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) {
      setRegForm(f => ({ ...f, referral_code: ref.toUpperCase() }));
      setShowReferral(true);
    }
  }, []);

  return (
    <AuthShell>
      <h1 style={{ fontSize: 22, fontWeight: 800, margin: 0, color: c.text }}>Join the Community</h1>
      <p style={{ fontSize: 13, color: c.sub, margin: "6px 0 24px" }}>Create your trusted account</p>

      {formError && (
        <div style={{ background: c.redBg, color: c.redTxt, padding: "9px 13px", borderRadius: 10, fontSize: 13, marginBottom: 14, textAlign: "left", border: `1px solid ${c.red}18` }}>
          {formError}
        </div>
      )}

      {/* Referral banner — shown when code auto-detected from URL */}
      {regForm.referral_code && (
        <div style={{ background: "linear-gradient(135deg, #6c5ce720, #a855f720)", border: "1.5px solid #6c5ce740", borderRadius: 12, padding: "10px 14px", marginBottom: 16, display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 20 }}>🎯</span>
          <div>
            <div style={{ fontSize: 12, fontWeight: 800, color: c.pri }}>Referral code applied!</div>
            <div style={{ fontSize: 11, color: c.sub }}>You'll both earn 50 GT on signup 🎉</div>
          </div>
        </div>
      )}

      <FormInput label="DISPLAY NAME" placeholder="Your name" value={regForm.name} onChange={e => setRegForm({ ...regForm, name: e.target.value })} />
      <FormInput label="EMAIL" type="email" placeholder="you@example.com" value={regForm.email} onChange={e => setRegForm({ ...regForm, email: e.target.value })} />
      <FormInput label="PASSWORD" type="password" placeholder="Min 8 chars, uppercase + number" value={regForm.password} onChange={e => setRegForm({ ...regForm, password: e.target.value })} />
      <FormInput label="CONFIRM PASSWORD" type="password" placeholder="Repeat password" value={regForm.confirm} onChange={e => setRegForm({ ...regForm, confirm: e.target.value })} onKeyDown={e => e.key === "Enter" && doRegister()} />

      {/* Referral code toggle */}
      {!showReferral ? (
        <button
          onClick={() => setShowReferral(true)}
          style={{ background: "none", border: "none", color: c.pri, fontSize: 12, fontWeight: 600, cursor: "pointer", marginBottom: 16, padding: 0 }}
        >
          🎯 Have a referral code? (optional)
        </button>
      ) : (
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: "block", fontSize: 10, fontWeight: 700, color: c.sub, marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.08em" }}>
            REFERRAL CODE (optional)
          </label>
          <input
            placeholder="e.g. ABC12345"
            value={regForm.referral_code || ""}
            onChange={e => setRegForm({ ...regForm, referral_code: e.target.value.toUpperCase() })}
            maxLength={10}
            style={{ width: "100%", padding: "12px 14px", borderRadius: 12, border: `1.5px solid ${regForm.referral_code ? c.pri : c.border}`, background: c.input, color: c.text, fontSize: 14, fontWeight: 700, letterSpacing: 2, outline: "none", boxSizing: "border-box", fontFamily: "monospace" }}
          />
          {regForm.referral_code && (
            <div style={{ fontSize: 11, color: "#10b981", fontWeight: 600, marginTop: 4 }}>
              ✅ Code entered — you'll both earn 50 GT!
            </div>
          )}
        </div>
      )}

      <Btn primary full onClick={doRegister} disabled={loading}>
        {loading ? "Creating account..." : "Create Account 🚀"}
      </Btn>

      {/* Signup bonus reminder */}
      <div style={{ background: "linear-gradient(135deg, #10b98110, #059669010)", border: "1px solid #10b98130", borderRadius: 12, padding: "10px 14px", marginTop: 14, display: "flex", alignItems: "center", gap: 10 }}>
        <span style={{ fontSize: 18 }}>🪙</span>
        <div style={{ fontSize: 12, color: c.sub, lineHeight: 1.5 }}>
          <strong style={{ color: "#10b981" }}>Free 50 G-Tokens</strong> just for signing up!
        </div>
      </div>

      <p style={{ textAlign: "center", marginTop: 18, fontSize: 13, color: c.sub }}>
        Already have an account?{" "}
        <button onClick={() => { go("login"); setFormError(""); }} style={{ color: c.pri, fontWeight: 700, cursor: "pointer", border: "none", background: "none", fontSize: 13 }}>
          Sign In
        </button>
      </p>
    </AuthShell>
  );
};

export const ForgotPage = ({ resetForm, setResetForm, formError, setFormError }) => {
  const { c, go, flash } = useApp();
  const [step, setStep] = useState("email");
  const [code, setCode] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [loading, setLoading] = useState(false);

  const sendCode = async () => {
    if (!resetForm.email) return setFormError("Enter your email");
    setLoading(true);
    setFormError("");
    const res = await api("/auth/forgot-password", { method: "POST", body: JSON.stringify({ email: resetForm.email }) });
    setLoading(false);
    if (res.ok) { flash("Reset code sent! Check your email"); setStep("code"); }
    else setFormError(res.data?.message || "Failed to send code");
  };

  const resetPassword = async () => {
    if (!code || code.length !== 6) return setFormError("Enter the 6-digit code from your email");
    if (!newPass || newPass.length < 8) return setFormError("New password must be at least 8 characters");
    if (newPass !== confirmPass) return setFormError("Passwords don't match");
    setLoading(true);
    setFormError("");
    const res = await api("/auth/reset-password", { method: "POST", body: JSON.stringify({ email: resetForm.email, code, password: newPass, password_confirmation: confirmPass }) });
    setLoading(false);
    if (res.ok) { flash("Password reset! You can now log in"); go("login"); }
    else setFormError(res.data?.message || "Failed to reset password");
  };

  const whatsappLink = `https://wa.me/254798515610?text=${encodeURIComponent("Hi Admin, I need help resetting my password. My email is: " + (resetForm.email || "[my email]"))}`;

  return (
    <AuthShell>
      <h1 style={{ fontSize: 22, fontWeight: 800, margin: 0, color: c.text }}>Reset Password</h1>
      {step === "email" && <p style={{ fontSize: 13, color: c.sub, margin: "6px 0 20px" }}>Enter your email to receive a 6-digit reset code</p>}
      {step === "code" && <p style={{ fontSize: 13, color: c.sub, margin: "6px 0 20px" }}>Check <strong>{resetForm.email}</strong> for your reset code</p>}
      {formError && <div style={{ background: c.redBg, color: c.redTxt, padding: "9px 13px", borderRadius: 10, fontSize: 13, marginBottom: 14, textAlign: "left", border: "1px solid " + c.red + "18" }}>{formError}</div>}

      {step === "email" && <>
        <FormInput label="EMAIL" type="email" placeholder="you@example.com" value={resetForm.email} onChange={e => setResetForm({ email: e.target.value })} />
        <Btn primary full onClick={sendCode} disabled={loading}>{loading ? "Sending..." : "Send Reset Code"}</Btn>
      </>}

      {step === "code" && <>
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: "block", fontSize: 10, fontWeight: 700, color: c.sub, marginBottom: 4, textTransform: "uppercase" }}>6-DIGIT CODE FROM EMAIL</label>
          <input type="text" maxLength={6} value={code} onChange={e => setCode(e.target.value.replace(/\D/g, ""))} placeholder="000000"
            style={{ width: "100%", padding: "14px 16px", borderRadius: 12, border: "1px solid " + c.border, background: c.input, color: c.text, fontSize: 24, fontWeight: 800, textAlign: "center", letterSpacing: 8, fontFamily: "monospace", outline: "none", boxSizing: "border-box" }} />
        </div>
        <FormInput label="NEW PASSWORD" type="password" placeholder="Min 8 characters" value={newPass} onChange={e => setNewPass(e.target.value)} />
        <FormInput label="CONFIRM PASSWORD" type="password" placeholder="Repeat password" value={confirmPass} onChange={e => setConfirmPass(e.target.value)} />
        <Btn primary full onClick={resetPassword} disabled={loading}>{loading ? "Resetting..." : "Reset Password"}</Btn>
        <button onClick={() => { setStep("email"); setFormError(""); }} style={{ width: "100%", marginTop: 8, padding: "8px 0", background: "none", border: "none", color: c.sub, fontSize: 12, cursor: "pointer" }}>← Didn't receive code? Try again</button>
      </>}

      <div style={{ background: c.input, borderRadius: 10, padding: "10px 14px", marginTop: 14, border: "1px solid " + c.border }}>
        <div style={{ fontSize: 11, color: c.sub, lineHeight: 1.5 }}>Still having trouble? <a href={whatsappLink} target="_blank" rel="noopener noreferrer" style={{ color: "#25D366", fontWeight: 700, textDecoration: "none" }}>WhatsApp Admin</a> for help.</div>
      </div>

      <p style={{ textAlign: "center", marginTop: 14, fontSize: 13, color: c.sub }}><button onClick={() => go("login")} style={{ color: c.pri, fontWeight: 700, cursor: "pointer", border: "none", background: "none", fontSize: 13 }}>← Back to Sign In</button></p>
    </AuthShell>
  );
};